<template>
  <!-- 气泡容器 -->
  <div class="toast-container">
    <!-- 循环渲染消息列表 -->
    <div
      v-for="item in toastList"
      :key="item.id"
      class="toast-item"
      :class="`toast-${item.type}`"
      :style="{ opacity: item.show ? 1 : 0, transform: item.show ? 'translateY(0)' : 'translateY(-20px)' }"
    >
      {{ item.message }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// 配置项
const CONFIG = {
  maxShow: 5,        // 最大同时显示数量
  duration: 3000,    // 默认显示时长(ms)
  animateTime: 300   // 动画时长(ms)
}

// 响应式消息列表
const toastList = ref([])
// 消息ID（唯一标识）
let toastId = 0

// 显示气泡（核心方法）
const showToast = (message, type = 'info', duration = CONFIG.duration) => {
  // 生成唯一ID
  const id = ++toastId
  // 添加消息到列表
  toastList.value.push({ id, message, type, show: false })

  // 触发显示动画
  setTimeout(() => {
    const item = toastList.value.find(i => i.id === id)
    if (item) item.show = true
  }, 10)

  // 自动隐藏
  setTimeout(() => {
    hideToast(id)
  }, duration)
}

// 隐藏单个气泡
const hideToast = (id) => {
  const item = toastList.value.find(i => i.id === id)
  if (!item) return

  // 关闭动画
  item.show = false
  // 动画结束后删除元素
  setTimeout(() => {
    toastList.value = toastList.value.filter(i => i.id !== id)
  }, CONFIG.animateTime)
}

// 清空所有气泡
const clearAllToast = () => {
  toastList.value.forEach(item => item.show = false)
  setTimeout(() => {
    toastList.value = []
  }, CONFIG.animateTime)
}

// 暴露方法给父组件/全局调用
defineExpose({
  showToast,
  clearAllToast,
  // 快捷方法
  success: (msg, duration) => showToast(msg, 'success', duration),
  warning: (msg, duration) => showToast(msg, 'warning', duration),
  error: (msg, duration) => showToast(msg, 'error', duration),
  info: (msg, duration) => showToast(msg, 'info', duration)
})
</script>

<style scoped>
/* 气泡容器：固定顶部居中 */
.toast-container {
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 100%;
  max-width: 80%;
  pointer-events: none;
}

/* 单个气泡样式 */
.toast-item {
  transition: all 0.3s ease;
  border-radius: 50px;
  padding: 10px 25px;
  text-align: center;
  font-size: 15px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  white-space: nowrap;
}

/* 四种状态样式 */
:deep(.toast-success) { background: #e6f7ee; color: #07b15b; }
:deep(.toast-warning) { background: #fff7e6; color: #ff9500; }
:deep(.tost-error) { background: #feeef0; color: #f53f3f; }
:deep(.toast-info) { background: #e6f7ff; color: #1890ff; }
</style>
